import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { colors } from '../../utils/colors';
import { getImagePath } from '../../utils/pathUtils';
import { FaBook, FaHome, FaPhoneAlt, FaStar } from 'react-icons/fa';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`} style={{ backgroundColor: '#ffffff' }}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <a href="#home">
            <img 
              src={getImagePath('skillyatra_logo.png')} 
              alt="SkillYatra Logo" 
              className="nav-logo"
            />
          </a>
        </div>
        
        <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <div className={`menu-icon ${isMobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        
        <ul className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <a href="#home" onClick={() => setIsMobileMenuOpen(false)}>
              <FaHome className="nav-icon" />
              <span>Home</span>
            </a>
          </li>
          <li className="nav-item">
            <a href="#courses" onClick={() => setIsMobileMenuOpen(false)}>
              <FaBook className="nav-icon" />
              <span>Courses</span>
            </a>
          </li>
          <li className="nav-item">
            <a href="#reviews" onClick={() => setIsMobileMenuOpen(false)}>
              <FaStar className="nav-icon" />
              <span>Reviews</span>
            </a>
          </li>
          <li className="nav-item">
            <a href="#contact" onClick={() => setIsMobileMenuOpen(false)}>
              <FaPhoneAlt className="nav-icon" />
              <span>Contact</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
